module.exports = __webpack_public_path__ + "img/bubble-corner-top.cb039636.svg";